import { redirect } from "next/navigation";
export default function SystemSecurityRedirectPage() {
  redirect("/admin/profile?tab=system");
}
